import { render, staticRenderFns } from "./FireOutbreakCantRelateReaction.vue?vue&type=template&id=f92c545c"
import script from "./FireOutbreakCantRelateReaction.vue?vue&type=script&lang=ts&setup=true"
export * from "./FireOutbreakCantRelateReaction.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports